import React from 'react';

import { Button } from '@mui/material';

import { RESET } from '../../constants/LoansCalculator';

export const ResetRatesButton = ({ onResetRates }) => {
  return (
    <Button
      sx={{
        '&:hover': { backgroundColor: 'black', color: 'white' },
        m: 0,
        color: 'white',
        backgroundColor: 'black',
        float: 'right',
        borderRadius: '10px',
        height: '48px',
        width: '120px',
      }}
      onClick={onResetRates}
    >
      {' '}
      {RESET}
    </Button>
  );
};
